import api from './api'

const resource = '/aspects'

export default {
    get(page, q) {
        return api.get(`${resource}?page=${page}&q=${q}`);
    },
    create(params) {
        return api.post(`${resource}`, params);
    },
    update(id, params) {
        return api.put(`${resource}/${id}`, params);
    },
    delete(id) {
        return api.delete(`${resource}/${id}`);
    }
}